export default __webpack_public_path__ + "static/media/applelogin.7cd88d82.svg";